import { Book, type BookRaw } from './Book';
import { CorporateTax, type CorporateTaxRaw } from './CorporateTax';

export class BookSetting {
  private constructor(
    readonly books: Book[],
    readonly corporateTax: CorporateTax,
  ) {}

  static init() {
    return new BookSetting([], CorporateTax.init());
  }

  static fromRaw(raw: BookSettingRaw) {
    return new BookSetting(Book.fromRaws(raw.books), CorporateTax.fromRaw(raw.corporateTax));
  }
}

export interface BookSettingRaw {
  readonly books: BookRaw[];
  readonly corporateTax: CorporateTaxRaw;
}
